<template>
  <v-card class="ma-3">
    <base-loading v-if="loading" />
    <crud-list
      v-else
      v-model="gestores"
      :headers="headers"
      :slots="['item.Celular', 'item.ATIVO']"
      :actions="actions"
      @itemsFiltered="handleListFiltered"
    >
      <template v-slot:btnCadastro>
        <v-row>
          <v-col>
            <v-btn
              color="green darken-1"
              dark
              class="rounded-lg"
              :loading="loadingSheet"
              @click="exportSheet"
            >
              <v-icon class="mr-2">mdi-file-excel</v-icon>

              <span style="font-size: 16px; font-weight: 600">Exportar</span>
            </v-btn>
          </v-col>
          <v-col>
            <router-link :to="`/${$user.get().role}/gestores/form`">
              <v-btn color="success"> Novo Gestor </v-btn>
            </router-link>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.ATIVO`]="{ item }">
        <v-btn
          v-if="item.ATIVO === 'Ativo' || item.ATIVO === 1"
          rounded
          small
          plain
          text
          class="teal lighten-1 white--text"
          @click="updateStatus(item)"
          >{{ item.ATIVO }}</v-btn
        >
        <v-btn
          v-else
          text
          rounded
          small
          plain
          class="red lighten-1 white--text"
          @click="updateStatus(item)"
          >{{ item.ATIVO }}</v-btn
        >
      </template>
      <template v-slot:[`item.Celular`]="{ item }">
        {{ item.Celular ? celular(item.Celular) : ' - ' }}
      </template>
    </crud-list>
  </v-card>
</template>

<script>
import { celular } from '../../utils/masks'
import { JsonToExcel } from '../../utils/Worksheet'

export default {
  data() {
    return {
      actions: [
        {
          title: 'Editar gestor',
          color: 'yellow darken-3',
          click: item =>
            this.$router.push({
              path: 'gestores/form',
              query: {
                CodGestor: item.CodGestor,
              },
            }),
          icon: 'mdi-pencil',
        },
        {
          title: 'Inativar gestor',
          color: 'red darken-3',
          click: item => this.deleteItem(item),
          icon: 'mdi-delete',
        },
      ],
      gestores: [],
      listFiltered: [],
      loading: true,
      loadingSheet: false,
      headers: [
        {
          text: '',
          sortable: false,
          width: '80px',
          value: 'actions',
          align: 'left',
        },
        {
          text: 'Status',
          sortable: true,
          width: 'auto',
          value: 'ATIVO',
          align: 'left',
          filterable: true,
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'Nome',
          width: 'auto',
        },
        {
          text: 'Email',
          align: 'left',
          sortable: true,
          value: 'Email',
          width: 'auto',
        },
        {
          text: 'Telefone',
          align: 'left',
          sortable: true,
          value: 'Celular',
          width: 'auto',
        },
        {
          align: 'left',
          sortable: true,
          text: 'Agroindústria',
          value: 'Agroindustria',
          width: 'auto',
        },
      ],
    }
  },
  created() {
    this.getGestores()
  },
  methods: {
    celular,
    handleListFiltered(value) {
      this.listFiltered = value
    },
    getGestores() {
      this.api.get.gestores(null, true).then(data => {
        data = data.map(item => {
          item.Agroindustria = item.Agroindustria.map(
            item => ' ' + item.agroindustria?.pessoajuridica?.NomeFantasia,
          )
          item.ATIVO = this.typeState(item.ATIVO)
          return item
        })

        this.gestores = data
        this.loading = false
      })
    },

    updateStatus(item) {
      if (
        this.$user.get().role === 'admin' ||
        this.$user.get().role === 'consultoria'
      ) {
        this.Swal.fire({
          title: `${item.ATIVO === 'Ativo' ? 'Inativar' : 'Ativar'} Gestor`,
          text: `Tem certeza que deseja ${
            item.ATIVO === 'Ativo' ? 'inativar' : 'ativar'
          } este gestor?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#ff5252',
          confirmButtonText: `Sim, desejo ${
            item.ATIVO === 'Ativo' ? 'inativar' : 'ativar'
          }!`,
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            this.api.update
              .gestorState(item.CodGestor, {
                state: item.ATIVO === 'Ativo' ? 0 : 1,
              })
              .then(res => {
                this.gestores = this.gestores.map(gestor => {
                  if (gestor.CodGestor === item.CodGestor) {
                    gestor.ATIVO = item.ATIVO === 'Ativo' ? 'Inativo' : 'Ativo'
                  }
                  return gestor
                })
                this.Swal.fire({
                  title: 'Sucesso',
                  text: `Gestor ${
                    res.ATIVO ? 'ativado' : 'inativado'
                  } com sucesso`,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                })
              })
            return true
          },
        })
      } else {
        this.Swal.fire(
          'Não permitido!',
          'Somente o Admin pode alterar o Status dos Gestores.',
          'error',
        )
      }
    },

    typeState(status) {
      if (status == '1') {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },

    exportSheet() {
      this.loadingSheet = true

      new JsonToExcel(
        this.listFiltered,
        this.headers,
        'gestores.xlsx',
        'Gestores',
      )

      this.loadingSheet = false
    },
    deleteItem(item) {
      this.Swal.fire({
        icon: 'error',
        title: 'Inativar Gestor',
        text: 'Você tem certeza que deseja inativar este gestor?',
        showCancelButton: true,
        confirmButtonColor: '#f74242',
        confirmButtonText: 'SIM, INATIVAR',
        cancelButtonText: 'NÃO',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.api.delete.gestor(item.CodGestor).then(
            () => {
              return 1
            },
            reject => {
              return reject
            },
          )
        },
        allowOutsideClick: () => !this.Swal.isLoading(),
      }).then(result => {
        if (result.value === 1) {
          this.loading = true
          this.getGestores()
          this.Swal.fire({
            title: 'Sucesso',
            text: 'O gestor foi inativado com sucesso!',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          })
        }
      })
    },
  },
}
</script>
